import React from 'react';
import { TextInput, required, SelectInput, ReferenceInput } from 'react-admin';
import PropTypes from 'prop-types';

import { Grid } from '@material-ui/core';

const CourseForm = ({
  nameLabel,
  statusLabel,
  status,
  clientsLabel,
  licenseLabel,
}) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={12} md={4}>
      <TextInput
        source="name"
        label={nameLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={4}>
      <SelectInput
        source="status"
        defaultValue={status[0].id}
        choices={status}
        label={statusLabel}
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={4}>
      <TextInput
        type="number"
        source="price"
        label="Precio"
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={6}>
      <ReferenceInput
        label={clientsLabel}
        source="clientId.id"
        reference="clients"
        perPage={90000}
      >
        <SelectInput fullWidth optionText="name" />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} sm={12} md={6}>
      <ReferenceInput
        label={licenseLabel}
        source="licenseId.id"
        reference="licenses"
        perPage={90000}
      >
        <SelectInput fullWidth optionText="name" />
      </ReferenceInput>
    </Grid>
  </Grid>
);

CourseForm.propTypes = {
  nameLabel: PropTypes.string.isRequired,
  statusLabel: PropTypes.string.isRequired,
  status: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  clientsLabel: PropTypes.string.isRequired,
  licenseLabel: PropTypes.string.isRequired,
};

export default CourseForm;
